import { format_currency } from "@/utils/currencies";
import { IActiveLot, ILot } from "@/models";
import { useAuctionStore } from "@/stores/AuctionStore";

const formatCatalogValueRange = (lotData: IActiveLot | ILot, forSeller = false): string | null => {
  if (!lotData?.catalogs?.length) {
    return null;
  }

  // Same logic for buyer and seller: min-max range across all catalogs that have a value.
  const values = lotData.catalogs.filter((catalog) => catalog.value).map((catalog) => catalog.value);
  if (!values.length) {
    return null;
  }

  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = min !== max ? format_currency(min) + " - " + format_currency(max) : format_currency(min);

  return forSeller ? `CV ${range}` : range;
};

const humanizedCatalog = (lot: IActiveLot, forSeller = false) => {
  if (lot.catalogs?.length) {
    if (forSeller) {
      const firstCatalog = lot.catalogs[0];
      return `${firstCatalog.name} ${firstCatalog.number}`;
    } else {
      return lot.catalogs.map((catalog) => `${catalog.name} ${catalog.number}`).join(", ");
    }
  }
  return null;
};

const humanizedCondition = (lot: IActiveLot, forSeller = false) => {
  if (lot.conditions?.length) {
    if (forSeller) {
      return lot.conditions
        .slice(0, 2)
        .map((condition) => condition.name)
        .join(", ");
    } else {
      return lot.conditions.map((condition) => condition.name).join(", ");
    }
  }
  return null;
};

const updateLotFieldById = (lotId: number, field: any, value: any) => {
  if (!lotId) {
    return;
  }
  const auctionStore = useAuctionStore();

  auctionStore.$patch((storeState) => {
    if (storeState.popupLot?.id === lotId) {
      storeState.popupLot[field] = value;
    }

    if (storeState.activeLot?.id === lotId) {
      storeState.activeLot[field] = value;
    }
    if (storeState.catalog.searchLots?.length) {
      const lotIndex = storeState.lots.findIndex((item) => item.id === lotId);
      if (lotIndex >= 0) {
        storeState.lots[lotIndex][field] = value;
      }
    }

    if (storeState.catalog.searchLots?.length) {
      const lotIndex = storeState.catalog.searchLots.findIndex((item) => item.id === lotId);
      if (lotIndex >= 0) {
        storeState.catalog.searchLots[lotIndex][field] = value;
      }
    }
  });
};

export { formatCatalogValueRange, humanizedCatalog, humanizedCondition, updateLotFieldById };
